module.exports = __webpack_public_path__ + "img/banner_info.92e0043f.jpg";